// extracted by mini-css-extract-plugin
export default {"container":"QuienesSomos_container__BgEvJ","section":"QuienesSomos_section__-hCHj","title":"QuienesSomos_title__PDDm-","text":"QuienesSomos_text__9MB4w"};